import { TFunction } from 'i18next'
import { WaitlistStatus } from './Types'

export function waitlistStatusText(t: TFunction<'translation', undefined>, status: WaitlistStatus) {
    if (status === 'isAccepted') {
        return t('Waiting for others to join...')
    } else if (status === 'isDenied') {
        return t('Denied access.')
    } else if (status === 'isWaitlisted') {
        return t('Waiting for the host to accept...')
    } else if (status === 'isJoining') {
        return t('Joining room...')
    } else if (status === 'isFullSession') {
        return t('Session is full.')
    }
}
